/**
 * 通知权限管理 & 消息通知触发
 */
export default class ChatNotification {
  // 初始化：请求通知权限 + 注册 Service Worker
  static async init() {
    // 1. 检测浏览器支持
    if (!('Notification' in window) || !('serviceWorker' in navigator)) {
      console.warn('当前浏览器不支持消息通知');
      return false;
    }

    // 2. 注册 Service Worker
    await this.registerServiceWorker();

    // 3. 请求通知权限（需用户主动交互触发，这里返回权限状态）
    const permission = Notification.permission;
    if (permission === 'granted') return true;
    if (permission === 'denied') return false;
    // 未授权时返回待授权状态，由业务侧绑定点击事件触发
    return 'pending';
  }

  // 注册 Service Worker
  static async registerServiceWorker() {
    try {
      // debugger;
      const registration = await navigator.serviceWorker.register('/assets/js/sw.js', { scope: '/assets/js/' });
      // 监听 Service Worker 更新
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('Service Worker 更新完成，刷新后生效');
          }
        });
      });
      return registration;
    } catch (error) {
      console.error('Service Worker 注册失败:', error);
      throw error;
    }
  }

  // 主动请求通知权限（需绑定到用户点击事件）
  static async requestPermission() {
    if (Notification.permission === 'granted') return true;
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  // 触发新消息通知（区分前台/后台）
  static async triggerNewMessage(payload) {
    const { title, body, sender, avatar } = payload;
    // 1. 检测权限
    if (Notification.permission !== 'granted') {
      console.warn('通知权限未授予，无法显示消息通知');
      return;
    }

    // 2. 判断应用状态：前台直接显示，后台通过 Service Worker 显示
    if (document.visibilityState === 'visible') {
      // 前台：直接调用 Notification API
      console.log("triggerNewMessage：前台显示")
      new Notification(title, {
        body,
        icon: avatar || '/assets/images/mainbody/logo.png',
        requireInteraction: true
      });
    } else {
      console.log("triggerNewMessage：后台显示")
      // 后台：给 Service Worker 发消息，由其触发通知
      const swRegistration = await navigator.serviceWorker.ready;
      swRegistration.active.postMessage({
        type: 'NEW_CHAT_MESSAGE',
        payload: { title, body, sender, avatar }
      });
    }
  }

  // 关闭所有通知
  static closeAllNotifications() {
    if (Notification.permission === 'granted') {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => reg.getNotifications().then(notis => notis.forEach(noti => noti.close())));
      });
    }
  }
}